import Vue from 'vue'
import Vuex from 'vuex'
import Project from '@/api/Project'
import Page from '@/api/Page'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    firstTime: true,
    projects: [],
    projectsLoaded: false,
    categories: [],
    categoriesLoaded: false,
    options: {
      contact: {},
      scenes: {}
    },
    title: '',
    mode: 'light',
    animationEnded: false,
  },
  getters: {
    firstTime: (state) => {
      return state.firstTime
    },
    projects: (state) => {
      return state.projects
    },
    projectsLoaded: (state) => {
      return state.projectsLoaded
    },
    categories: (state) => {
      return state.categories
    },
    categoriesLoaded: (state) => {
      return state.categoriesLoaded
    },
    mapReady: (state) => {
      return state.projectsLoaded && state.categoriesLoaded
    },
    contact: (state) => {
      return state.options.contact
    },
    mode: (state) => {
      return state.mode
    },
    title: (state) => {
      return state.title
    },
    scenes: (state) => {
      return state.options.scenes
    },
    animationEnded: (state) => {
      return state.animationEnded
    }
  },
  mutations: {
    UPDATE_FIRST: (state, payload) => {
      state.firstTime = payload
    },
    SET_PROJECTS: (state, payload) => {
      state.projects = payload.projects
      state.projectsLoaded = payload.loaded
    },
    SET_CATEGORIES: (state, payload) => {
      state.categories = payload.categories
      state.categoriesLoaded = payload.loaded
    },
    SET_OPTIONS: (state, payload) => {
      state.options = payload.acf
    },
    SET_LIGHT_MODE: (state) => {
      state.mode = 'light'
    },
    SET_DARK_MODE: (state) => {
      state.mode = 'dark'
    },
    SET_TITLE: (state, payload) => {
      state.title = payload
    },
    UPDATE_ANIMATION: (state, payload) => {
      state.animationEnded = payload
    }
  },
  actions: {
    removeFirstTime({ commit }) {
      commit('UPDATE_FIRST', false)
    },
    async fetchProjects({ commit }, payload) {
      const res = await new Project().fetchProjects()
      commit('SET_PROJECTS', { projects: res.data, loaded: true })
    },
    async fetchCategories({ commit }, payload) {
      const res = await new Project().fetchCategories()
      commit('SET_CATEGORIES', { categories: res.data, loaded: true })
    },
    async fetchOptions({ commit }, payload) {
      const res = await new Page().fetchOptions()
      commit('SET_OPTIONS', res.data)
    },
    setLightMode({ commit}) {
      commit('SET_LIGHT_MODE')
    },
    setDarkMode({ commit}) {
      commit('SET_DARK_MODE')
    },
    setTitle({ commit}, payload) {
      commit('SET_TITLE', payload)
    },
    updateAnimation({ commit }, payload) {
      commit('UPDATE_ANIMATION', payload)
    }
  },
})
